<template>
    <div id="konfigurator-narozeniny">

        <h1>{{ 'Enter the age of your dog' | translate }}</h1>

        <div v-show="(!isValidYear() || !isValidMonth() || !isValidDay()) && this.tryEscape" class="info-messages-box">
            <div v-if="(!isValidYear() || !isValidMonth() || !isValidDay()) && this.tryEscape" class="error-msg">
                {{ 'You must select the number of years and months or the full date of birth.' | translate }}
            </div>
        </div>

        <div class="form-content">

            <div class="stari-items">

                <div class="stari-item">
                    <div class="form-type-select">
                        <label>{{ 'Years' | translate }}</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.vypocetRok"
                                    @change="onChangeVypocet">
                                <option :key="key" v-for="(item, key) in vypocetRokyItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<v-select :options="vypocetRokyItems" :value="mazlicek.narozeniny.vypocetRok" :on-change="onChangeVypocet">
                            </v-select>-->
                        </div>
                    </div>
                </div>
                <div class="stari-item">
                    <div class="form-type-select">
                        <label>{{ 'Months' | translate }}</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.vypocetMesic"
                                    @change="onChangeVypocet">
                                <option :key="key" v-for="(item, key) in vypocetMesiceItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<v-select :options="vypocetMesiceItems" :value="mazlicek.narozeniny.vypocetMesic" :on-change="onChangeVypocet">
                            </v-select>-->
                        </div>
                    </div>
                </div><!-- /.col-md-6 -->

            </div><!-- /.row -->

            <p>{{ 'or date of birth' | translate }}</p>

            <div class="narozeniny-items">

                <div class="narozeniny-item">
                    <div class="form-type-select"
                         v-bind:class="{ 'has-error':!isValidDay() && this.tryEscape,'has-success':isValidDay() }">
                        <label>{{ 'Day' | translate }}</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.narozeniDen"
                                    @change="onChangeNarozeniny">
                                <option :key="key" v-for="(item, key) in narozeniDenItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<vue-select class="vue-select3" name="select3" :options="narozeniDenItems" :model.sync="mazlicek.narozeniny.narozeniDen"-->
                            <!--:onChange="onChangeNarozeniny">-->
                            <!--</vue-select>-->
                        </div>
                    </div>
                </div><!-- /.col-md-4 -->
                <div class="narozeniny-item">
                    <div class="form-type-select"
                         v-bind:class="{ 'has-error':!isValidMonth() && this.tryEscape,'has-success':isValidMonth() }">
                        <label>{{ 'Month' | translate }}</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.narozeniMesic"
                                    @change="onChangeNarozeniny">
                                <option :key="key" v-for="(item, key) in narozeniMesiceItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<v-select :options="narozeniMesiceItems" :value="mazlicek.narozeniny.narozeniMesic" :on-change="onChangeNarozeniny">
                            </v-select>-->
                        </div>
                    </div>
                </div>
                <div class="narozeniny-item">
                    <div class="form-type-select"
                         v-bind:class="{ 'has-error':!isValidYear() && this.tryEscape,'has-success':isValidYear() }">
                        <label>{{ 'Year' | translate }}</label>
                        <div class="select-content">
                            <select class="form-select" v-model="mazlicek.narozeniny.narozeniRok"
                                    @change="onChangeNarozeniny">
                                <option :key="key" v-for="(item, key) in narozeniRokyItems" v-bind:value="item.value">{{ item.label }}
                                </option>
                            </select>
                            <!--<v-select :options="narozeniRokyItems" :value="mazlicek.narozeniny.narozeniRok" :on-change="onChangeNarozeniny">
                            </v-select>-->
                        </div>
                    </div>
                </div>

            </div><!-- ./row -->


        </div>

        <div v-if="isTooYoung" class="infobox">{{
                "Your dog is still too young for Haffit. For your first order, come when he is at least 6 weeks old. We'll look forward to it!" | translate
            }}</div>

        <info :krok="4"></info>

        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :disableNext="!valid || isTooYoung"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>


    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import moment from 'moment'
    import navigace from './Navigace'
    import info from './Info'
    import translateFilter from '../services/translator.js';
    // import VueSelect from '../src/vue-select2'

    export default {
        components: {
            navigace,
            info,
            // "vue-select": require("../select/vue-select2.js")
            // vSelect
        },
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                tryEscape: false,
                model: null,
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.narozeniny.valid = !this.$v.mazlicek.narozeniny.$invalid)
            },
            formatDatumNarozeni: function () {
                return moment(this.mazlicek.narozeniny.value).format('D.M.Y')
            },
            vekRoku: function () {
                return Math.floor(moment().diff(this.mazlicek.narozeniny.value, 'years', true))
            },
            vekRokuMesicu: function () {
                return Math.floor(moment().diff(this.mazlicek.narozeniny.value, 'months', true)) - this.vekRoku * 12
            },
            formatVekRoku: function () {
                return Math.round(moment().diff(this.mazlicek.narozeniny.value, 'years', true) * 100) / 100
            },
            formatVekMesicu: function () {
                return Math.round(moment().diff(this.mazlicek.narozeniny.value, 'months', true) * 100) / 100
            },
            formatVekDnu: function () {
                return Math.round(moment().diff(this.mazlicek.narozeniny.value, 'days', true) * 100) / 100
            },
            vypocetRokyItems: function () {
                var a = []
                var i = 0
                a.push({value: -1, label: this.translateFilter('Choose a year')})
                for (i = 0; i <= 50; i++) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            vypocetMesiceItems: function () {
                var a = []
                var i = 0
                a.push({value: -1, label: this.translateFilter('Choose a month')})
                for (i = 0; i <= 12; i++) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            narozeniRokyItems: function () {
                var start = new Date().getFullYear()
                var a = []
                var i = 0
                a.push({value: -1, label: this.translateFilter('Choose a year')})
                for (i = start; i >= (start - 50); i--) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            narozeniMesiceItems: function () {
                var a = []
                var i = 0
                a.push({value: -1, label: this.translateFilter('Choose a month')})
                for (i = 1; i <= 12; i++) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            narozeniDenItems: function () {
                var a = []
                var i = 0
                a.push({value: -1, label: this.translateFilter('Choose a day')})
                for (i = 1; i <= 31; i++) {
                    a.push({value: String(i), label: String(i)})
                }
                return a
            },
            isTooYoung(){
                if(this.mazlicek.narozeniny.value){
                   return moment().diff(this.mazlicek.narozeniny.value, 'days') / 7.0 < 6
                } else {
                   return false
                }
            },
        },
        methods: {
            translateFilter,
            onChangeVypocet: function () {
                if (this.mazlicek.narozeniny.vypocetRok !== -1 && this.mazlicek.narozeniny.vypocetMesic !== -1) {
                    var ret = (moment().subtract(this.mazlicek.narozeniny.vypocetRok, 'years').subtract(this.mazlicek.narozeniny.vypocetMesic, 'months'))
                    this.mazlicek.narozeniny.narozeniRok = ret.year()
                    this.mazlicek.narozeniny.narozeniMesic = ret.month() + 1
                    this.mazlicek.narozeniny.narozeniDen = moment().dates()
                    this.mazlicek.narozeniny.value = moment().year(this.mazlicek.narozeniny.narozeniRok).month(this.mazlicek.narozeniny.narozeniMesic - 1).date(this.mazlicek.narozeniny.narozeniDen)
                } else {
                    this.mazlicek.narozeniny.narozeniRok = -1
                    this.mazlicek.narozeniny.narozeniMesic = -1
                    this.mazlicek.narozeniny.narozeniDen = -1
                    this.mazlicek.narozeniny.value = null
                }
            },
            onChangeNarozeniny: function () {
                if (this.mazlicek.narozeniny.narozeniRok !== -1 && this.mazlicek.narozeniny.narozeniMesic !== -1 && this.mazlicek.narozeniny.narozeniDen !== -1) {
                    this.mazlicek.narozeniny.value = moment().year(this.mazlicek.narozeniny.narozeniRok).month(this.mazlicek.narozeniny.narozeniMesic - 1).date(this.mazlicek.narozeniny.narozeniDen)
                    this.mazlicek.narozeniny.vypocetRok = this.vekRoku
                    this.mazlicek.narozeniny.vypocetMesic = this.vekRokuMesicu
                } else {
                    this.mazlicek.narozeniny.vypocetRok = -1
                    this.mazlicek.narozeniny.vypocetMesic = -1
                    this.mazlicek.narozeniny.value = null
                }
            },
            setBirthDay() {
                this.onChangeNarozeniny()
            },
            prev: function () {
                this.$router.push({name: 'fotografie'})
            },
            saveAndQuit: function () {
              if (this.isvalidstep() && !this.isTooYoung) {
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    this.mazlicek.jeStene = response.data.data.node.field_mazlicek_je_stene.und && response.data.data.node.field_mazlicek_je_stene.und[0].value == '1'

                    window.location.href = 'prihlaseni'
                  }, error => {
                    console.error(error)
                  })
              } else {
                this.tryEscape = true
                this.animateAfterError()
              }
            },
            next: function () {
                // this.$store.commit('setMazlicek', this.mazlicek)
                if (this.isvalidstep() && !this.isTooYoung) {
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {
                            this.mazlicek.jeStene = response.data.data.node.field_mazlicek_je_stene.und && response.data.data.node.field_mazlicek_je_stene.und[0].value == '1'

                            this.$router.push({name: 'pohlavi'})
                        }, error => {
                            console.error(error)
                        })
                } else {
                    this.tryEscape = true
                    this.animateAfterError()
                }
            },
            isValidYear: function () {
                return this.mazlicek.narozeniny.narozeniRok !== -1
            },
            isValidMonth: function () {
                return this.mazlicek.narozeniny.narozeniMesic !== -1
            },
            isValidDay: function () {
                return this.mazlicek.narozeniny.narozeniDen !== -1
            },
            isvalidstep: function () {
                return this.isValidYear() && this.isValidMonth() && this.isValidDay()
            },
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            }
        },
        validations: {
            mazlicek: {
                narozeniny: {
                    value: {
                        required,
                        valid: function () {
                            return moment(this.mazlicek.narozeniny.value).isValid()
                        }
                    }
                }
            }
        },
        mounted: function () {
          // TODO: nacitani hodnot pri refreshi
            this.mazlicek.step.current = 4
            this.$cookies.set('lastVisitedStep', 4)
            jQuery('html, body').animate({scrollTop: 0}, '500')
            if (this.mazlicek.narozeniny.value !== null) {
                this.mazlicek.narozeniny.narozeniRok = -1
                this.mazlicek.narozeniny.narozeniMesic = -1
                this.mazlicek.narozeniny.narozeniDen = -1

                let petDate = this.mazlicek.narozeniny.value
                this.mazlicek.narozeniny.narozeniRok = petDate.year()
                this.mazlicek.narozeniny.narozeniMesic = petDate.month() + 1
                this.mazlicek.narozeniny.narozeniDen = petDate.date()
                this.setBirthDay()
            } else {
                this.mazlicek.narozeniny.vypocetRok = -1
                this.mazlicek.narozeniny.vypocetMesic = -1
                this.mazlicek.narozeniny.narozeniDen = -1
                this.mazlicek.narozeniny.narozeniMesic = -1
                this.mazlicek.narozeniny.narozeniRok = -1
            }
        }
    }
</script>



// WEBPACK FOOTER //
// 04Narozeniny.vue?4d624b4d